import PropTypes from "prop-types";
import React from "react";
import DocumentTitle from "react-document-title";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { nav } from "../../nav/actions";
import { notifications } from "../actions";

class Landing extends React.Component {
  componentDidUpdate() {
    const { clearNotifications, loggedIn } = this.props;
    if (loggedIn) {
      clearNotifications();
    }
  }

  render() {
    const { login, loggedIn } = this.props;
    if (loggedIn) {
      return <Redirect to="/policies" />;
    }
    return (
      <div className="l-landing">
        <DocumentTitle title="RBAC - Welcome" />
        <div className="l-landing__column">
          <div className="l-landing__column-header" />
          <div className="l-landing__column-panel" />
        </div>
        <div className="l-landing__column">
          <div className="l-landing__column-header" />
          <div className="l-landing__column-panel" />
        </div>
        <div className="l-landing__column">
          <div className="l-landing__column-header" />
          <div className="l-landing__column-panel" />
        </div>
        <div className="l-landing__footer" />
        <div className="l-landing__box p-card--highlighted">
          <p className="p-heading--four">Login</p>
          <p>Welcome to RBAC, click Login to begin.</p>
          <div className="u-align--right">
            <button
              data-role="login-button"
              className="p-button--positive u-no-margin--bottom"
              type="button"
              onClick={login}
            >
              Login
            </button>
          </div>
        </div>
      </div>
    );
  }
}

Landing.displayName = "Landing";

Landing.propTypes = {
  login: PropTypes.func.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  clearNotifications: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  login: nav.loginStart,
  clearNotifications: notifications.clear
};

const mapStateToProps = state => ({
  loggedIn: state.user.loggedIn
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Landing);
